import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const PageWrapper = styled.div`
  padding: 24px 0 60px;
`;

export const TwoColumnLayout = styled.div`
  display: flex;
  gap: 40px;
  margin-top: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
  }
`;

export const LeftColumn = styled.div`
  width: 40%;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }
`;

export const CoverImageWrapper = styled.div`
  width: 100%;
  aspect-ratio: 2 / 3;
  border-radius: ${({ theme }) => theme.metrics.radius.medium};
  overflow: hidden;
  background: ${({ theme }) => theme.colors.bgSecondary};
  box-shadow: 0 4px 20px ${({ theme }) => theme.colors.shadow};
`;

export const CoverImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.dark.little};
  font-size: ${({ theme }) => theme.typography.sizes.lg};
  font-family: ${({ theme }) => theme.typography.body};
`;

export const RightColumn = styled.div`
  flex: 1;
  min-width: 0;
`;

export const BookTitle = styled.h1`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.xxl};
  color: ${({ theme }) => theme.colors.text.dark.very};
  margin: 0 0 8px 0;
  line-height: 1.2;
`;

export const AuthorLink = styled(Link)`
  font-family: ${({ theme }) => theme.typography.body};
  font-size: ${({ theme }) => theme.typography.sizes.lg};
  color: ${({ theme }) => theme.colors.primary.main};
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.primary.dark};
    text-decoration: underline;
  }
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 24px;
  margin-top: 20px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const InfoLabel = styled.span`
  font-size: ${({ theme }) => theme.typography.sizes.xs};
  color: ${({ theme }) => theme.colors.text.dark.little};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-family: ${({ theme }) => theme.typography.body};
`;

export const InfoValue = styled.span`
  font-size: ${({ theme }) => theme.typography.sizes.md};
  color: ${({ theme }) => theme.colors.text.dark.very};
  font-family: ${({ theme }) => theme.typography.body};
`;

export const SellerSection = styled.div`
  margin-top: 20px;
  padding: 16px;
  background: ${({ theme }) => theme.colors.bgSecondary};
  border-radius: ${({ theme }) => theme.metrics.radius.medium};
`;

export const SellerLabel = styled.span`
  font-size: ${({ theme }) => theme.typography.sizes.xs};
  color: ${({ theme }) => theme.colors.text.dark.little};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: block;
  margin-bottom: 6px;
`;

export const SellerLink = styled(Link)`
  font-size: ${({ theme }) => theme.typography.sizes.md};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.dark.very};
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const SellerRating = styled.div`
  margin-top: 6px;
`;

export const CopiesText = styled.div`
  margin-top: 8px;
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.text.dark.medium};
`;

export const PriceSection = styled.div`
  margin-top: 24px;
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
`;

export const SynopsisSection = styled.div`
  margin-top: 48px;
`;

export const SynopsisTitle = styled.h2`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.xl};
  color: ${({ theme }) => theme.colors.text.dark.very};
  margin: 0 0 16px 0;
`;

export const SynopsisText = styled.p`
  font-family: ${({ theme }) => theme.typography.body};
  font-size: ${({ theme }) => theme.typography.sizes.md};
  color: ${({ theme }) => theme.colors.text.dark.medium};
  line-height: 1.7;
  margin: 0;
`;

export const RecentSection = styled.div`
  margin-top: 48px;
`;

export const RecentTitle = styled.h2`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.xl};
  color: ${({ theme }) => theme.colors.text.dark.very};
  margin: 0 0 16px 0;
`;

export const RecentScroll = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;

  & > * {
    flex-shrink: 0;
    width: 220px;
  }

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.border};
    border-radius: 3px;
  }
`;

export const NotFoundWrapper = styled.div`
  padding: 80px 0;
  text-align: center;
`;

export const NotFoundTitle = styled.h2`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.xl};
  color: ${({ theme }) => theme.colors.text.dark.very};
  margin: 0 0 8px 0;
`;

export const NotFoundText = styled.p`
  font-size: ${({ theme }) => theme.typography.sizes.md};
  color: ${({ theme }) => theme.colors.text.dark.little};
  margin: 0;
`;

export const ListingsSection = styled.div`
  margin-top: 24px;
`;

export const ListingsTitle = styled.h3`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.lg};
  color: ${({ theme }) => theme.colors.text.dark.very};
  margin: 0 0 16px 0;
`;

export const ListingCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  background: ${({ $active, theme }) => ($active ? theme.colors.bgSecondary : '#fff')};
  border: 1px solid ${({ $active, theme }) => ($active ? theme.colors.primary.main : theme.colors.border)};
  border-radius: ${({ theme }) => theme.metrics.radius.medium};
  margin-bottom: 10px;
  transition: border-color 0.2s;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary.main};
  }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ListingSellerInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ListingSellerName = styled(Link)`
  font-weight: 600;
  font-size: ${({ theme }) => theme.typography.sizes.md};
  color: ${({ theme }) => theme.colors.text.dark.very};
  text-decoration: none;
  display: block;

  &:hover {
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const ListingMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 6px;
  flex-wrap: wrap;
`;

export const ListingCopies = styled.span`
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.text.dark.little};
`;

export const ListingPriceArea = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
`;

export const ListingThumbnail = styled.div`
  width: 64px;
  height: 86px;
  border-radius: ${({ theme }) => theme.metrics.radius.small};
  overflow: hidden;
  background: ${({ theme }) => theme.colors.bgSecondary};
  flex-shrink: 0;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: ${({ $isPlaceholder }) => ($isPlaceholder ? 'sepia(0.15) brightness(0.95)' : 'none')};
  }
`;

export const ThumbnailLabel = styled.span`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 9px;
  text-align: center;
  padding: 2px 0;
  line-height: 1.2;
`;
